<template>
    <popup :opened="dataToShow > -1" @close="changeToShow(-1)">

        <!-- BEGIN message to confirm delete a referent -->
        <div
            v-if="dataToShow == 1"
            class="mx-5 xl:mx-16 2xl:mx-20 my-8 w-auto h-auto"
        >
            <h3 class="mb-10  text-pink-600">Confirmation de suppression</h3>

            <h6 class="text-indigo-600 mb-10">
                Êtes vous sûr de vouloir supprimer le référent {{referentToEdit.firstname}} <span class="uppercase">{{referentToEdit.lastname}}</span> ? <br>
                Cette suppression sera définitive et irrévocable.
            </h6>

            <div class="w-full flex justify-center">
                <div class="mr-5">
                    <action-button 
                        class=" relative flex flex-row"
                        border-color="border-pink-600"
                        text-color="text-pink-600"
                        bg-color="bg-pink-300"
                        libelle="ANNULER"
                        @clickAction="changeToShow(-1)"
                    />
                </div>
                <div class="w-auto">
                    <action-button 
                        class=" relative flex flex-row"
                        border-color="border-transparent"
                        text-color="text-white"
                        bg-color="bg-pink-600"
                        libelle="SUPPRIMER"
                        type-shadow="shadow-pink"
                        @clickAction="confirmDeleteReferent()"
                    />
                </div>
            </div>
        </div>
        <!-- END message to confirm delete a referent -->

        <!-- BEGIN message to confirm the suppression of the referent -->
        <div v-if="dataToShow == 2" class="mx-5 xl:mx-16 2xl:mx-20 my-8 w-auto h-auto">
            <h3 class="text-indigo-600 mb-10">Le référent {{referentToEdit.firstname}} <span class="uppercase">{{referentToEdit.lastname}}</span> a bien été supprimé</h3>

            <div class="w-full flex justify-center">
                <illustration name="basket" class="w-full" />
            </div>
        </div>
        <!-- END message to confirm delete a referent -->

        <!-- BEGIN message to confirm the suppression of the referent -->
        <div v-if="dataToShow == 100" class="mx-5 xl:mx-16 2xl:mx-20 my-8 w-auto h-auto">
            <h3 class="w-full text-pink-600 mb-10">Erreur lors de la suppression du référent !</h3>

            <div class="mb-10">
                <p class="text-indigo-600 text-lg text-center">Le référent n'a pas pu être supprimé.</p>
            </div>

            <illustration name="notAllowed" class="w-full" />
        </div>
        <!-- END message to confirm delete a referent -->
    </popup>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Popup from './../../../components/Popup';
import Icon from './../../../components/Icon';
import Illustration from './../../../components/Illustration';
import ActionButton from './../../../components/ActionButton';


export default {
  name:'DeleteReferentPopup',

  props:{
    dataToShow: Number,
  },

  data() {
    return {

    };
  },

  components:{
    Popup,
    Icon,
    ActionButton,
    Illustration,
  },

  computed:{
    ...mapGetters({
      saving: 'permissions/saving',
      referentToEdit: 'referents/referentToEdit',
    }),
  },

  methods:{
    ...mapActions({
      deleteReferent: 'referents/deleteReferent'
    }),

    ...mapMutations({
      SET_SAVING: 'permissions/SET_SAVING',
    }),

    changeToShow(val){
      this.$emit('showChange', val);
    },

    confirmDeleteReferent(){
      this.deleteReferent().then((r) => {
        this.changeToShow(2);
      }).catch(error => {
        console.log('ERRRR:: ', error.response);
        this.changeToShow(100);
      });
    }
  }
};
</script>
